export const STATISTIC_MEASURE_GROUPING_MAX_COUNT = 3
